export const getGapWorkStatementWorkCellValue = (
    audio: TrqkGapChannelAudio,
): GapWorkStatementWorkCellValue => {
    const { gap_audio_id, matched_work_id } = audio;
    const matchOptions = audio?.match_options ?? [];

    const dropdownInputOptions = matchOptions.map(
        (matchOption: TrqkGapChannelAudioMatchOption): DropdownInputOption => ({
            id: matchOption.song_id,
            label: matchOption.work_title,
            value: {
                gapAudioId: matchOption.gap_audio_id,
                songId: matchOption.song_id,
            },
        }),
    );

    return {
        dropdownInputOptions,
        matchedWorkId: matched_work_id ?? null,
        gapAudioId: gap_audio_id,
    };
};
